import React from "react";
import { observer } from "mobx-react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import "./SummaryHeader.css";
import { Link } from "react-router-dom";
import productPlaceholder from "../Images/placeholder_config_image.png";


type Props = {
	selectedModulesCounter: string;
};

@observer
class SummaryHeader extends React.Component<Props> {
	render() {
		const imageUrl = store.productConfigurationStore?.product?.productBase?.image?.url ? store.productConfigurationStore?.product?.productBase?.image?.url : productPlaceholder;

		return (
			<div className="summary-header">
				<div className="container">
					<div className="row">
						<div className="col-lg-6">
							<div className="summary-headline-wrapper">
								<p className="summary-topline">{store.configs?.summaryTopline}</p>
								<h1 className="summary-headline">{store.configs?.summaryHeadline}</h1>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="summary-box-wrapper">
								<div className="summary-box-section image">
									<img
										className="product-image"
										src={imageUrl}
										alt={store.productConfigurationStore?.product?.title?.rendered}
									/>
									{store.productConfigurationStore?.getRenderImages.map((imageUrl: string, i) => {
										return <img src={imageUrl} alt="" className="config-image" key={`${i}-renderImage`} />;
									})}
								</div>
								<div className="summary-box-section text">
									<div className="summary-box-headline">{store.configs?.summarySummaryBoxHeadline}</div>
									<p className="summary-box-text">
										{store.productConfigurationStore?.product?.title?.rendered + " " + this.props.selectedModulesCounter}
									</p>
								</div>
								<Link className="btn btn-primary summary-box-button" to="/sales-partner">
									{store.configs?.toplineRequest}
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SummaryHeader;
